<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch" autocomplete="off">
    <el-form-item label="搜索范围">
      <!-- <el-date-picker
        v-model="dateRange"
        type="daterange"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        range-separator="-"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateChange"
      /> -->
      <el-date-picker
        v-model="dateStartRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="开始时间"
        :disabled-date="disabledDate"
        @change="handleDateStartChange"
      />
      <el-date-picker
        v-model="dateEndRange"
        type="date"
        format="YYYY/MM/DD"
        value-format="YYYY/MM/DD"
        placeholder="结束时间"
        :disabled-date="disabledDate"
        @change="handleDateEndChange"
      />
    </el-form-item>
    <el-form-item label="商品ID">
      <el-input v-model="queryParam.goodsnum" type="textarea" placeholder="多个商品ID使用回车分割" autosize @blur="autoFormat('goodsnum', { unique: true })" />
    </el-form-item>
    <el-form-item label="活动名称">
      <el-input v-model.trim="queryParam.activityname" placeholder="输入活动名称" />
    </el-form-item>
    <el-form-item label="客户">
      <el-select
        v-model="queryParam.customerid"
        filterable
        placeholder="选择客户"
      >
        <template v-for="item in customerData" :key="item.customerid">
          <el-option :label="item.name" :value="item.customerid" />
        </template>
      </el-select>
    </el-form-item>
    <!-- <el-form-item label="客户">
      <el-input v-model.trim="queryParam.customername" placeholder="输入客户" />
    </el-form-item> -->
    <el-form-item label="商品名称">
      <el-input v-model.trim="queryParam.name" placeholder="输入商品名称" />
    </el-form-item>
    <!-- <el-form-item label="供应商">
      <el-select
        v-model="queryParam.supplierids"
        filterable
        multiple
        placeholder="选择供应商"
      >
        <template v-for="item in supplierData" :key="item.supplierid">
          <el-option :label="item.name" :value="item.supplierid" />
        </template>
      </el-select>
    </el-form-item> -->
    <!-- <el-form-item label="商品类目">
      <el-cascader
        placeholder="请选择商品类目"
        filterable
        v-model="queryParam.catalogid"
        :options="catalogData"
        :show-all-levels="false"
        :props="catalogQueryProps"
      />
    </el-form-item> -->
    <!-- <el-form-item label="开票类型">
        <el-select v-model="queryParam.taxtype" placeholder="开票类型">
          <el-option label="增值税专用发票" :value="1" />
          <el-option label="增值税普通发票" :value="2" />
          <el-option label="不开票" :value="3" />
        </el-select>
    </el-form-item> -->
    <el-form-item label="货源状态">
        <el-select v-model="queryParam.gsstatus" placeholder="货源状态">
          <el-option label="上架" :value="1" />
          <el-option label="下架" :value="2" />
        </el-select>
    </el-form-item>
    <!-- <el-form-item label="品牌名称">
      <el-select v-model="queryParam.brandid" 
        filterable 
        multiple         
        placeholder="选择品牌">
        <template v-for="item in brandData" :key="item.brandid">
          <el-option :label="item.name" :value="item.brandid" />
        </template>
      </el-select>
    </el-form-item> -->
    <el-form-item label="成本价">
      <el-col :span="11">
        <el-form-item prop="lowcostprice1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowcostprice1" :min="0" :precision="2" controls-position="right" placeholder="最小值" class="rangeWidth" />
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowcostprice2">
          <el-input-number v-model="queryParam.lowcostprice2" :min="0" :precision="2" controls-position="right" placeholder="最大值" class="rangeWidth" />
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="市场价">
      <el-col :span="11">
        <el-form-item prop="lowmarketprice1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowmarketprice1" :min="0" :precision="2" controls-position="right" placeholder="最小值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowmarketprice2">
          <el-input-number v-model="queryParam.lowmarketprice2" :min="0" :precision="2" controls-position="right" placeholder="最大值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
    </el-form-item>
    <el-form-item label="商品折扣">
      <el-col :span="11">
        <el-form-item prop="lowdiscount1" style="margin-right:0">
          <el-input-number v-model="queryParam.lowdiscount1" :min="0" :precision="2" :step="0.1" controls-position="right" placeholder="最小值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
      <el-col :span="2" style="text-align: center">
        <span>-</span>
      </el-col>
      <el-col :span="11">
        <el-form-item prop="lowdiscount2">
          <el-input-number v-model="queryParam.lowdiscount2" :min="0" :precision="2" :step="0.1" controls-position="right" placeholder="最大值" class="rangeWidth"/>
        </el-form-item>
      </el-col>
    </el-form-item>
    <!-- <el-form-item label="状态">
        <el-select v-model="queryParam.status" placeholder="商品状态">
          <el-option label="正常" :value="1" />
          <el-option label="停用" :value="2" />
        </el-select>
      </el-form-item> -->
    <el-form-item>
      <el-button type="danger" @click="getListGoodsGiftPack">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
         <el-button
          type="primary"
          @click="doGetGoodsGiftPackTrashList"
          v-hasPermission="['goods']"
          >回收站</el-button
        >
        <el-button
          type="danger"
          @click="(dialog = true), doGoodsGiftPackAdd()"
          v-hasPermission="['goods:goodsGiftPack:add']"
          >新增礼包商品</el-button
        >
        <el-button
          type="danger"
          @click="openImport('goods:importGiftPack')"
          v-hasPermission="['goods:importGiftPack']"
          >导入礼包商品</el-button
        >
        <el-button
          type="danger"
          @click="openImport('goods:importGiftPackEdit')"
          v-hasPermission="['goods:importGiftPackEdit']"
          >批量导入礼包商品修改</el-button
        >
        <el-button
          type="danger"
          :loading="loadingexport" @click="doExportGoodsGiftPack"
          v-hasPermission="['goods:goodsGiftPack:export']"
          >{{loadingexport ? "处理中 ..." : "导出礼包商品"}}<el-tooltip content="一次最多导出8万左右条数据，更多数据请精细化搜索" placement="top-end" effect="light"><el-icon class="elicon"><InfoFilled /></el-icon></el-tooltip></el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
      ref="tableRef"
        :data="tableData"
        v-loading="loadingData"
        @selection-change="doSelectionGoodsGiftPack"
        class="mainTable"
        row-key="goodsid"
        height="600"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="selection" width="55" />
       
        <el-table-column label="商品ID" prop="goodsnum" width="250">
          <template #default="scope">
          <span>{{ scope.row.goodsnum }}</span>
          <el-icon class="is-loading" v-if="scope.row.loading" @click="loadChildren(scope.row)">
            <Loading />
          </el-icon>
        </template>
        </el-table-column>
        <el-table-column label="商品名称" prop="name" width="200"/>
        <el-table-column label="商品规格" prop="specification" width="200" />
        <el-table-column label="客户" prop="customername" width="200"/>
        <el-table-column label="活动名称" prop="activityname" width="200"/>
        <!-- <el-table-column label="礼包单品SKU编码" prop="giftsku" width="200" /> -->
        <el-table-column label="成本价" align="center" prop="goodsSuppliers[0].costprice">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].costprice" v-text="(scope.row.goodsSuppliers[0].costprice).toFixed(2)" />
          </template>
        </el-table-column>
        <!-- <el-table-column label="市场价" align="center" prop="goodsSuppliers[0].marketprice"/> -->
        <el-table-column label="销售价" align="center" prop="goodsSuppliers[0].saleprice">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].saleprice" v-text="(scope.row.goodsSuppliers[0].saleprice).toFixed(2)" />
          </template>
        </el-table-column>
        <el-table-column label="毛利额" align="center" prop="goodsSuppliers[0].maolieamount">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].maolieamount" v-text="(scope.row.goodsSuppliers[0].maolieamount).toFixed(2)" />
            <span v-else v-text="'0.00'" />
          </template>
        </el-table-column>
        <el-table-column label="毛利率" align="center" prop="goodsSuppliers[0].maoliv">
          <template #default="scope">
            <span v-if="scope.row.goodsSuppliers[0].maoliv" v-text="(scope.row.goodsSuppliers[0].maoliv*100).toFixed(2) + '%'" />
            <span v-else v-text="'0.00%'" />
          </template>
        </el-table-column>
        <!-- <el-table-column label="商品折扣" align="center" prop="goodsSuppliers[0].discount">
          <template #default="scope">
          <span v-text="(scope.row.goodsSuppliers[0].discount*100).toFixed(0) + '%'" />
          </template>
        </el-table-column> -->
        <el-table-column label="供应商" align="center" prop="goodsSuppliers[0].supplier.name"/>
        <el-table-column label="发货快递" align="center" prop="goodsSuppliers[0].express"/>
        <el-table-column label="商品备注1" align="center" prop="note1" width="200" />
        <!-- <el-table-column label="品牌" align="center" prop="brandname"/>
        <el-table-column label="类目" prop="catalogname" width="150"/> -->
        <el-table-column label="货源状态" align="center" prop="goodsSuppliers[0].status">
          <template #default="scope">
          <el-tag
              round
              :type="scope.row.goodsSuppliers[0].status === 1 ? 'success' : 'danger'"
              disable-transitions
              ><span v-text="util.showGoodsStatus(scope.row.goodsSuppliers[0].status)"></span
            ></el-tag>
          </template>
        </el-table-column>
        <el-table-column label="日期" prop="created" width="150">
          <template #default="scope">
            <span
              v-text="
                util.formatDateUnix(scope.row.created, 'yyyy-MM-dd hh:mm')
              "
            ></span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="状态" prop="status">
            <template #default="scope">
              <el-switch
                :value="scope.row.status"
                :active-value="1"
                :inactive-value="2"
                size="small"
                @change="doGoodsGiftPackStatus(scope.$index, scope.row, 'status')"
              />
            </template> -->
        <!-- </el-table-column> -->
        <el-table-column label="操作" fixed="right" width="130">
          <template #default="scope">
          <el-link
            type="primary"
            size="small"
            v-if="!scope.row.hasChildren && scope.row.loaded"
            @click="loadChildren(scope.row)"
          >
            查看商品
          </el-link>

            <el-link
              type="primary"
              size="small"
              @click="(dialog = true), doGoodsGiftPackEdit(scope.$index, scope.row)"
              v-hasPermission="['goods:edit']"
              v-if="scope.row.loaded"
              >编辑</el-link
            >

            <el-link
              type="primary"
              size="small"
              @click="open('goods:view', scope.row)"
              v-hasPermission="['goods:view']"
              v-if="scope.row.loaded"
              >供应商</el-link
            >

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此礼包商品吗？"
              v-if="scope.row.loaded"
              width="200px"
              @confirm="doGoodsGiftPackDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>

            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除此商品吗？"
              v-if="!scope.row.loaded"
              width="200px"
              @confirm="doGoodsGiftPackDeleteChild(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除商品</el-link
                >
              </template>
            </el-popconfirm>

            <el-popconfirm
              v-if="scope.row.status===1 && scope.row.loaded"
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要此商品移到回收站吗？"
              width="200px"
              @confirm="doGoodsGiftPackTrash(scope.$index, scope.row, 2)"
            >
              <template #reference>
                <el-link
                  v-hasPermission="['goods:goodsGiftPack:remove']"
                  size="small"
                  type="danger"
                  >移到回收站</el-link
                >
              </template>
            </el-popconfirm>

            <el-popconfirm
              v-if="scope.row.status===2 && scope.row.loaded"
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要此商品恢复到商品库吗？"
              width="200px"
              @confirm="doGoodsGiftPackTrash(scope.$index, scope.row, 1)"
            >
              <template #reference>
                <el-link
                  v-hasPermission="['goods:goodsGiftPack:recover']"
                  size="small"
                  type="danger"
                  >恢复礼包库</el-link
                >
              </template>
            </el-popconfirm>

          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8">
      <div>
          <el-button type="danger" v-if="queryParam.status===1" @click="showBatchGoodsGiftRemoveRecoverDialog('goodsRemove')" v-hasPermission="['goods:goodsGiftPack:remove']">批量移动回收站</el-button>
          <el-button type="danger" v-if="queryParam.status===2" @click="showBatchGoodsGiftRemoveRecoverDialog('goodsRecover')" v-hasPermission="['goods:goodsGiftPack:recover']">批量恢复礼包库</el-button>
      </div>
    </el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[20, 50, 100, 300, 600, 1000, 2000]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
          :current-page="queryParam.pageNo"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :close-on-click-modal="false"
    :title="title"
    direction="rtl"
    size="55%"
    @close="doGoodsGiftPackClose()"
  >
    <div class="common-drawer__content">
      <el-form
        ref="goodsFormRef"
        :model="goodsForm"
        :rules="rules"
        label-width="150px"
        autocomplete="off"
      >
        <el-form-item label="商品类目" prop="catalogid">
          <el-cascader
            style="width: 100%"
            placeholder="请选择商品类目"
            v-model="goodsForm.catalogid"
            :options="catalogData"
            :show-all-levels="false"
            :props="catalogProps"
            @change="getCatalog"
            ref="catalogCascaderRef"
          />
        </el-form-item>

        <el-form-item label="品牌" prop="brandid">
          <el-select
            style="width: 100%"
            v-model="goodsForm.brandname"
            filterable
            placeholder="选择品牌"
            @change="getBrand"
            ref="brandRef"
          >
            <template v-for="item in brandData" :key="item.brandid">
              <el-option :label="item.name" :value="item.brandid" />
            </template>
          </el-select>
        </el-form-item>
         <!-- <el-form-item label="客户" prop="customername">
          <el-input
            v-model.trim="goodsForm.customername"
            placeholder="请输入客户"
          />
        </el-form-item> -->
        <el-form-item label="客户" prop="customerid">
          <el-select
            v-model="goodsForm.customername"
            filterable
            style="width:100%"
            placeholder="选择客户"
            @change="getCustomer"
            ref="customerRef"
          >
            <template v-for="item in customerData" :key="item.customerid">
              <el-option :label="item.name" :value="item.customerid" />
            </template>
          </el-select>
        </el-form-item>
         <el-form-item label="活动名称" prop="activityname">
          <el-input
            v-model.trim="goodsForm.activityname"
            placeholder="请输入活动名称"
          />
        </el-form-item>
        <el-form-item label="商品名称" prop="name">
          <el-input
            v-model.trim="goodsForm.name"
            placeholder="请输入商品名称"
          />
        </el-form-item>
        <el-form-item label="商品IDS" prop="goodsnums">
          <el-input
            v-model.trim="goodsForm.goodsnums"
            type="textarea"
            placeholder="请输入商品IDS,以逗号分割,如:PY1199481414345830400,PY1199481015735955456"
          />
        </el-form-item>
        <el-form-item label="商品规格" prop="specification">
          <el-input
            v-model.trim="goodsForm.specification"
            type="textarea"
            autosize
            placeholder="请输入商品规格"
          />
        </el-form-item>
        <el-form-item label="商品描述" prop="specification">
          <el-input
            v-model.trim="goodsForm.desc"
            type="textarea"
            autosize
            placeholder="请输入商品描述"
          />
        </el-form-item>
        <el-form-item label="税收编码" prop="taxcode">
          <el-input
            v-model.trim="goodsForm.taxcode"
            placeholder="请输入税收编码"
          />
        </el-form-item>
        <el-form-item label="税收分类名称" prop="taxsort">
          <el-input
            v-model.trim="goodsForm.taxsort"
            placeholder="请输入税收分类名称"
          />
        </el-form-item>
        <el-form-item label="国际条形码" prop="barcode">
          <el-input
            v-model.trim="goodsForm.barcode"
            placeholder="请输入国际条形码"
          />
        </el-form-item>
        <!-- <el-form-item label="礼包单品SKU编码" prop="giftsku">
          <el-input
            type="textarea"
            v-model.trim="goodsForm.giftsku"
            placeholder="请输入礼包单品SKU编码"
          />
        </el-form-item> -->
        <el-form-item label="电商评价数" prop="erate">
          <el-input
            v-model.trim="goodsForm.erate"
            placeholder="请输入电商评价数"
          />
        </el-form-item>
        <el-form-item label="电商链接" prop="elink">
          <el-input
            v-model.trim="goodsForm.elink"
            placeholder="请输入电商链接"
          />
        </el-form-item>
        <el-form-item label="产地" prop="producer">
          <el-input
            v-model.trim="goodsForm.producer"
            placeholder="请输入产地"
          />
        </el-form-item>
        <el-form-item label="商品备注1" prop="note1">
          <el-input
            v-model.trim="goodsForm.note1"
            type="textarea"
            autosize
            placeholder="请输入商品备注1"
          />
        </el-form-item>
        <el-form-item label="商品备注2" prop="note2">
          <el-input
            v-model.trim="goodsForm.note2"
            type="textarea"
            autosize
            placeholder="请输入商品备注2"
          />
        </el-form-item>

        <el-divider />
        <h1>供应商信息</h1>
        <el-card
          class="box-card"
          shadow="never"
          style="margin-bottom: 10px"
          v-for="(supplier, index) in goodsForm.goodsSuppliers"
          :key="supplier.gsid"
        >
          <template #header>
            <div class="card-header">
              <span>供应商信息（{{ index + 1 }}）</span>
              <el-icon
                @click.prevent="deleteSupplier(supplier)"
                style="float: right;cursor: pointer;"
                ><Close
              /></el-icon>
            </div>
          </template>
          <el-form-item
            label="供应商"
            :prop="'goodsSuppliers.' + index + '.supplierid'"
            :rules="{
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            }"
          >
            <el-select
              style="width:100%"
              v-model="supplier.supplierid"
              filterable
              placeholder="选择供应商"
            >
              <template v-for="item in supplierData" :key="item.supplierid">
                <el-option :label="item.name" :value="item.supplierid" />
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="供应商商品ID"
            :prop="'goodsSuppliers.' + index + '.sgoodsnum'"
          >
            <el-input
              v-model.trim="supplier.sgoodsnum"
              placeholder="请输入供应商商品ID"
            />
          </el-form-item>
          <el-form-item
            label="成本价"
            :prop="'goodsSuppliers.' + index + '.costprice'"
            :rules="[{
              required: true,
              message: '请输入成本价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.costprice"
              placeholder="请输入成本价"
            />
          </el-form-item>
          <el-form-item
            label="市场价"
            :prop="'goodsSuppliers.' + index + '.marketprice'"
            :rules="[{
              required: true,
              message: '请输入市场价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.marketprice"
              placeholder="请输入市场价"
            />
          </el-form-item>
          <el-form-item
            label="销售价"
            :prop="'goodsSuppliers.' + index + '.saleprice'"
            :rules="[{
              required: true,
              message: '请输入销售价，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.saleprice"
              placeholder="请输入销售价"
            />
          </el-form-item>
          <!-- <el-form-item
            label="商品折扣"
            :prop="'goodsSuppliers.' + index + '.discount'"
            :rules="[{
              required: true,
              message: '请输入商品折扣，须是数字',
              trigger: 'blur',
            },{ required: true, validator: validateDecimal, trigger: 'blur' }]"
          >
            <el-input
              v-model="supplier.discount"
              placeholder="请输入商品折扣"
            />
          </el-form-item> -->
          <el-form-item
            label="发货地"
            :prop="'goodsSuppliers.' + index + '.delivery'"
          >
            <el-input
              v-model="supplier.delivery"
              placeholder="请输入发货地"
            />
          </el-form-item>
          <el-form-item
            label="发货快递"
            :prop="'goodsSuppliers.' + index + '.express'"
          >
            <el-input
              v-model="supplier.express"
              placeholder="请输入发货快递"
            />
          </el-form-item>
          <el-form-item
            label="货源状态"
            :prop="'goodsSuppliers.' + index + '.status'"
            :rules="{
              required: true,
              message: '请选择货源状态',
              trigger: 'change',
            }"
          >
            <el-radio-group v-model="supplier.status">
              <el-radio :label="1">上架</el-radio>
              <el-radio :label="2">下架</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="默认供应商"
            :prop="'goodsSuppliers.' + index + '.defstatus'"
            :rules="{
              required: true,
              message: '请选择默认供应商',
              trigger: 'change',
            }"
          >
            <el-radio-group v-model="supplier.defstatus" @change="changeDefaultStatus(index)">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-card>

        <el-button @click="addSupplier" type="danger">添加供应商</el-button>
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doGoodsGiftPackClose()">关闭</el-button>
        <el-button type="danger" :loading="loading" @click="doGoodsGiftPackSave">{{
          loading ? "提交中 ..." : "提交"
        }}</el-button>
      </div>
    </div>
  </el-drawer>

  <BatchGoodsGiftRemoveRecover ref="RefBatchGoodsGiftRemoveRecover" @click="getListGoodsGiftPack"/>

</template>
        
<script setup>
import { ref, onMounted,getCurrentInstance, nextTick  } from "vue";
import { useRouter } from "vue-router";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import { listGoodsGiftPack, listGoodsGiftPackChild, saveGoodsGiftPack, getGoodsGiftPackInfo, exportGoodsGiftPack, deleteGoodsGiftPack, deleteGoodsGiftPackChild,updateGoodsGiftPack } from "@/api/goodsGiftPack";

import { listSupplierCache } from "@/api/supplier";
import { listCatalogCache } from "@/api/catalog";
import { listBrandCache } from "@/api/brand";
import { listCustomerCache } from "@/api/customer";
import util from "@/util/tool.js";
import storage from  "@/util/storage";

import BatchGoodsGiftRemoveRecover from "@/components/common/batchGoodsGiftRemoveRecover";


// import store from "@/store";

const router = useRouter();
let open = (routeName, row) => {
  storage.saveSessionObject("goodsPath",queryParam.value)
  router.push({
    name: routeName,
    params: { id: row.goodsid },
    // query: { name: row.name },
  });
};
let openImport = (routeName)=>{
  router.push({
    name: routeName
  });
}

// let openGoodsGiftPackTemp = (routeName)=>{
//   router.push({
//     name: routeName
//   });
// }

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingexport = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const goodsFormRef = ref();

const total = ref(0);
const pageSize = ref(20); //每页显示条数

// let dateRange = ref([]);

let dateStartRange = ref();
let dateEndRange = ref();

let title = ref("新增礼包商品");

const multipleSelection = ref([]);
const doSelectionGoodsGiftPack = (val) => {
  multipleSelection.value = val;
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  activityname: "",
  customerid: "",
  customername: "",
  name: "",
  brandid: "",
  catalogid: "",
  supplierids: "",
  goodsnum: "",
  status: 1,
  isgift: 2,
  taxtype: "",
  gsstatus: "",
  lowcostprice1: null,
  lowcostprice2: null,
  lowmarketprice1: null,
  lowmarketprice2: null,
  lowdiscount1: null,
  lowdiscount2:null,
  created: "",
  changed: ""
});

const autoFormat = (key, opt = {}) => {
  queryParam.value[key] = util.formatLineText(queryParam.value[key], opt);
};

const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    activityname: "",
    customerid: "",
    customername: "",
    name: "",
    brandid: "",
    catalogid: "",
    supplierids: "",
    goodsnum: "",
    status: 1,
    isgift: 2,
    taxtype: "",
    gsstatus: "",
    lowcostprice1: null,
    lowcostprice2: null,
    lowmarketprice1: null,
    lowmarketprice2: null,
    lowdiscount1: null,
    lowdiscount2:null,
    created: "",
    changed: ""
  };
  defaultDate()
  getListGoodsGiftPack();
};

const goodsForm = ref({
  goodsid: null,
  name: null,
  catalogid: null,
  catalogname: null,
  brandid: null,
  brandname: null,
  customerid: null,
  customername: "",
  activityname: "",
  goodsnums: "",
  // giftsku: "",
  specification: "",
  desc: "",
  taxcode: "",
  taxsort: "",
  barcode: "",
  erate: "",
  elink: "",
  producer: "",
  note1: "",
  note2: "",
  supplierids: "",
  status: 1,
  isgift: 2,
  goodsSuppliers: [
    {
        gsid:null,
        supplierid: null,
        sgoodsnum: "",
        costprice: null,
        marketprice: null,
        saleprice: null,
        discount: null,
        delivery: "",
        express: "",
        status: 1,
        defstatus: 0,
    },
  ],
});

const defaultDate = () => {
    // const today = new Date()
    
    // // 一年前的日期
    // const startDate = new Date(today)
    // startDate.setFullYear(startDate.getFullYear() - 1)
  
    // // 格式化 YYYY-MM-DD
    // const formatDate = (date) => date.toISOString().slice(0, 10)
  
    // // 默认赋值
    // dateRange.value = [
    //   formatDate(startDate),
    //   formatDate(today)
    // ]
    // queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
    // queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");

    //dateRange.value = []
    dateStartRange.value = ''
    dateEndRange.value = ''
    queryParam.value.created = ""
    queryParam.value.changed = ""
}  
  // 2. 禁用逻辑：不能选未来，范围最大一年
  const disabledDate = (time) => {
    console.log(time)
    // const now = Date.now()
    // const oneYearMs = 365 * 24 * 60 * 60 * 1000
  
    // // 禁用未来日期
    // if (time.getTime() > now) return true
  
    // // 已选开始日期 → 结束日期只能选 开始 ~ 开始+1年
    // if (dateRange.value?.[0]) {
    //   const start = new Date(dateRange.value[0]).getTime()
    //   return time.getTime() < start || time.getTime() > start + oneYearMs
    // }
  
    // return false
  }
  
  // 3. 防止手动输入超过一年范围
  // const handleDateChange = () => {
  //   if (!dateRange.value) return
  
    // const start = new Date(dateRange.value[0]).getTime()
    // const end = new Date(dateRange.value[1]).getTime()
    // const oneYearMs = 365 * 24 * 60 * 60 * 1000
  
    // if (end - start > oneYearMs) {
    //   const maxEnd = new Date(start + oneYearMs)
    //   dateRange.value[1] = maxEnd.toISOString().slice(0, 10)
    // }
  //   queryParam.value.created = Date.parse(dateRange.value[0] + " 00:00:00");
  //   queryParam.value.changed = Date.parse(dateRange.value[1] + " 23:59:59");
  // }
  const handleDateStartChange = () => {
  if (!dateStartRange.value) return
  if (dateEndRange.value) {
    if (dateStartRange.value > dateEndRange.value) {
      dateStartRange.value = ""
      queryParam.value.created = ""
      ElMessage.error('开始时间须小于结束时间');
      return false
    }
  }
  queryParam.value.created = Date.parse(dateStartRange.value + " 00:00:00");
}

const handleDateEndChange = () => {
  if (!dateEndRange.value) return

  if (dateStartRange.value > dateEndRange.value) {
    dateStartRange.value = ""
    queryParam.value.created = ""
    ElMessage.error('开始时间须小于结束时间');
    return false
  }
  queryParam.value.changed = Date.parse(dateEndRange.value + " 23:59:59");
}

//批量移到回收站
let dialogBatchGoodsGiftRemoveRecoverVisible = ref(false);
const RefBatchGoodsGiftRemoveRecover = ref();
const showBatchGoodsGiftRemoveRecoverDialog = (flag) => {
  if (multipleSelection.value.length<=0) {
    ElMessage.error('请先选择要处理的礼包项');
    return false
  }
  RefBatchGoodsGiftRemoveRecover.value.changeVisible(!dialogBatchGoodsGiftRemoveRecoverVisible.value);

  let goodsids = []

  multipleSelection.value.forEach((goods) => {
      goodsids.push(goods.goodsid.toString())
  });

  RefBatchGoodsGiftRemoveRecover.value.goodsGiftRemoveRecoverMethod({
    goodsid: goodsids,
    status: flag==='goodsRemove'?2:1,
    flag: flag
  });
};

const changeDefaultStatus = (index) => {
  goodsForm.value.goodsSuppliers.forEach((supplier,i) => {
    console.log('supplier---',supplier)
    if (index != i) {
      goodsForm.value.goodsSuppliers[i].defstatus = 0
    }
  });
};

const catalogCascaderRef = ref()
const getCatalog = ()=> {
    //console.log(val)
    // console.log(catalogCascaderRef.value.getCheckedNodes()[0].label)
    // console.log(catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > '))
    goodsForm.value.catalogname = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')+'||'+catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > ');
    // goodsForm.value.catalogid = val.slice(-1) 
    //console.log('-catalogCascaderRef.value.-',catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(','))
    //goodsForm.value.catalogid = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')

}

let currentInstance = null
const brandRef = ref()
const getBrand = (selectedValue) => {
  nextTick(() => {
     // 这里不加nextTick会获取不到准确的值
    const {selectedLabel} = currentInstance.refs.brandRef
    goodsForm.value.brandname = selectedLabel
    goodsForm.value.brandid = selectedValue
  })
}

const customerRef = ref()
const getCustomer = (selectedValue) => {
  nextTick(() => {
     // 这里不加nextTick会获取不到准确的值
    const {selectedLabel} = currentInstance.refs.customerRef
    goodsForm.value.customername = selectedLabel
    goodsForm.value.customerid = selectedValue
  })
}

const addSupplier = () => {
  goodsForm.value.goodsSuppliers.push({
    supplierid: null,
    sgoodsnum: "",
    costprice: null,
    marketprice: null,
    saleprice: null,
    discount: null,
    delivery: "",
    express: "",
    status: 1,
    defstatus: 0
  });
};
const deleteSupplier = (supplier) => {
  const index = goodsForm.value.goodsSuppliers.indexOf(supplier);
  if (index !== -1) {
    goodsForm.value.goodsSuppliers.splice(index, 1);
  }
};

const tableRowClassName = ({
  row
}) => {
  if (row.parentid) {
    return 'warning-row'
  } 
  return ''
}

const tableData = ref([]);

//onMounted方法
onMounted(() => {
  let query = storage.getSessionObject("goodsPath")
  if (query) {
    queryParam.value = query
  }

  currentInstance = getCurrentInstance();

  defaultDate()

  getListBrand();
  getListSupplier();
  getListCatalog();
  getListCustomer();
  getListGoodsGiftPack();
});

//品牌列表API
const brandData = ref([]);
const brandReset = (brands) => {
  let dataTmp = [];
  brands.forEach((brand) => {
    brand.brandid = brand.brandid.toString();
    dataTmp.push(brand);
  });
  return dataTmp;
};
const getListBrand = () => {
  listBrandCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    brandData.value = brandReset(res.data.extend.pages.list);
  });
};

//客户列表API
const customerData = ref([]);
const customerReset = (customers) => {
  let dataTmp = [];
  customers.forEach((customer) => {
    customer.customerid = customer.customerid.toString();
    dataTmp.push(customer);
  });
  return dataTmp;
};
const getListCustomer = () => {
  listCustomerCache({ pageNo: 1, pageSize: 1000, status: 1 }).then((res) => {
    customerData.value = customerReset(res.data.extend.pages.list);
  });
};

//供应商列表API
const supplierData = ref([]);
const supplierReset = (suppliers) => {
  let dataTmp = [];
  suppliers.forEach((supplier) => {
    supplier.supplierid = supplier.supplierid.toString();
    dataTmp.push(supplier);
  });
  return dataTmp;
};
const getListSupplier = () => {
  listSupplierCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    supplierData.value = supplierReset(res.data.extend.pages.list);
  });
};

//类目API
// const catalogQueryProps = ref({
//   checkStrictly: true,
//   multiple: true,
//   //expandTrigger: "hover",
//   emitPath: false,
//   value: "catalogid",
//   label: "name",
// });
const catalogData = ref([]);
const catalogProps = ref({
  emitPath: false,
  value: "catalogid",
  label: "name",
});
const catalogReset = (catalogs) => {
  let dataTmp = [];
  catalogs.forEach((catalog) => {
    catalog.catalogid = catalog.catalogid.toString();
    catalog.parentid = catalog.parentid.toString();
    dataTmp.push(catalog);
    catalogReset(catalog.children);
  });
  return dataTmp;
};
const getListCatalog = () => {
  listCatalogCache({ pageNo: 1, pageSize: 5000, status: 1 }).then((res) => {
    catalogData.value = catalogReset(res.data.extend.pages.list);
  });
};

const doGoodsGiftPackAdd = () => {
  title.value = "新增礼包商品";
  resetForm()
  // goodsForm.value.goodsSuppliers = [
  //     {
  //       gsid: null,
  //       supplierid: null,
  //       sgoodsnum: "",
  //       costprice: null,
  //       marketprice: null,
  //       discount: null,
  //       status: 1
  //     },
  //   ]
};

const doGoodsGiftPackDelete = (index, obj) => {
  console.log(obj.goodsid.toString())
  deleteGoodsGiftPack({goodsid: obj.goodsid.toString()}).then((res) => {
    if (res.data.code === 1) {
      getListGoodsGiftPack();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}

const doGoodsGiftPackDeleteChild = (index, obj) => {
  console.log({goodsid: obj.parentid, goodsnum: obj.goodsnum, goodsnums: obj.goodsnums})
  deleteGoodsGiftPackChild({goodsid: obj.parentid, goodsnum: obj.goodsnum, goodsnums: obj.goodsnums}).then((res) => {
    if (res.data.code === 1) {
      getListGoodsGiftPack();
      // removeNodeById(tableData.value, obj.goodsid, obj.parentid)
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}


//回收站列表
const doGetGoodsGiftPackTrashList = () => {
  queryParam.value.status = 2
  getListGoodsGiftPack();
}

//回收站
const doGoodsGiftPackTrash = (index, obj, status) => {
  console.log(obj.goodsid.toString())
  updateGoodsGiftPack({status, goodsid:obj.goodsid.toString(), name: obj.name}).then((res) => {
    if (res.data.code === 1) {
      getListGoodsGiftPack();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
}

// const removeNodeById = (tree, targetId)=> {
//   for (let i = tree.length - 1; i >= 0; i--) {

//     if (tree[i].goodsid === targetId) {
//       // 如果是根节点直接删除
//       tree.splice(i, 1)
//       return true
//     }
    
//     if (tree[i].children && tree[i].children.length > 0) {
//       // 递归查找子节点
//       const found = removeNodeById(tree[i].children, targetId)
//       if (found) return true
//     }
//   }
//   return false
// }

const doGoodsGiftPackEdit = (index, obj) => {
  // console.log(index,obj)
  title.value = "编辑礼包商品";
  // goodsForm.value = obj;//直接赋值会出问题


  goodsForm.value.catalogname = obj.catalogid+'||'+obj.catalogname
  console.log(goodsForm.value.catalogname)

  let goodsid = obj.goodsid.toString()

  getGoodsGiftPackInfo({ goodsid}).then((res) => {
    goodsForm.value = res.data.extend.goods;
    goodsForm.value.goodsid = res.data.extend.goods.goodsid.toString()
    let catalogids = (res.data.extend.goods.catalogid).split(',')
   // console.log('catalogids----',catalogids,catalogids[catalogids.length-1])
    goodsForm.value.catalogid = catalogids[catalogids.length-1]
    //console.log('goodsForm.value.catalogid---',goodsForm.value.catalogid)
    //goodsForm.value.catalogid = res.data.extend.goods.catalogid.toString()
    goodsForm.value.brandid = res.data.extend.goods.brandid.toString()

    let goodsSuppliers = res.data.extend.goods.goodsSuppliers;

    let dataTmp = [];

    goodsSuppliers.forEach((supplier) => {
        supplier.supplierid = supplier.supplierid.toString();
        supplier.gsid = supplier.gsid.toString();
        //supplier.status = supplier.gsstatus;
        // supplier.discount = supplier.costprice / supplier.marketprice;
        dataTmp.push(supplier);

    });
    goodsForm.value.goodsSuppliers = dataTmp
  });
};

const doGoodsGiftPackClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  goodsFormRef.value.resetFields()
};

const resetForm = () => {
  goodsForm.value = {
    goodsid: null,
    name: null,
    catalogid: null,
    catalogname: null,
    brandid: null,
    brandname: null,
    customerid: null,
    customername: "",
    activityname: "",
    goodsnums: "",
    // giftsku: "",
    specification: "",
    desc: "",
    taxcode: "",
    taxsort: "",
    barcode: "",
    erate: "",
    elink: "",
    producer: "",
    note1: "",
    note2: "",
    supplierids: "",
    status: 1,
    isgift: 2,
    goodsSuppliers: [
      {
          gsid:null,
          supplierid: null,
          sgoodsnum: "",
          costprice: null,
          marketprice: null,
          saleprice: null,
          discount: null,
          delivery: "",
          express: "",
          status: 1,
          defstatus: 0,
      },
    ],
  };
};

const doGoodsGiftPackSave = () => {
  goodsFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    goodsForm.value.catalogname = catalogCascaderRef.value.getCheckedNodes()[0].pathValues.join(',')+'||'+catalogCascaderRef.value.getCheckedNodes()[0].pathLabels.join(' > ');

    let defstatusFlag = 0
    goodsForm.value.goodsSuppliers.forEach((supplier) => {
        supplier.discount = supplier.costprice / supplier.marketprice;
        if (supplier.defstatus===1) {
          defstatusFlag = 1
        }
    });
    if (!defstatusFlag) {
      ElMessage.error('请为商品设置默认供应商')
      return
    }

    console.log(goodsForm.value.goodsSuppliers)
    
    saveGoodsGiftPack(goodsForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListGoodsGiftPack();
          doGoodsGiftPackClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//更新用户状态
//   const doGoodsGiftPackStatus = (index, obj) => {
//     let status = obj.status == 1 ? 2 : 1;
//     let data = { status, name: obj.name, goodsid: obj.goodsid.toString() };
//     tableData.value[index].status = status;
//     saveGoodsGiftPack(data);
//   };

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListGoodsGiftPack();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListGoodsGiftPack();
};
const tableRef = ref()


// 手动加载子节点
const loadChildren = async (row) => {
  try {
    console.log(row.goodsnums)
    if (!row.goodsnums) { return false }
    row.loading = true
    const children = await fetchChildrenData(row.goodsnums, row.goodsid)
    
    // 手动添加子节点
    row.children = children
    row.loaded = true
    row.loading = false
    
    // 刷新表格视图
    tableData.value = [...tableData.value]

    setTimeout(() => {
    tableRef.value.toggleRowExpansion(row, true)

  }, 500)
        
  } catch (error) {
    console.error('加载失败:', error)
    row.loading = false
  }
}

const fetchChildrenData = (goodsnums, parentid) => {
  return new Promise(resolve => {
      listGoodsGiftPackChild({goodsnums: goodsnums, pageNo: 1,pageSize: 100}).then((res) => {//queryParam.value
        const children = goodsResetChild(res.data.extend.pages.list, goodsnums, parentid);
        resolve(children)
      });
  })
}

//在子商品保留父商品编码
const goodsResetChild = (children, goodsnums, parentid) => {
  let dataTmp = [];
  children.forEach((row) => {
    row.goodsnums = goodsnums
    row.parentid = parentid
    
    dataTmp.push(row);
  });
  return dataTmp;
};

const goodsReset = (perms) => {
  let dataTmp = [];
  perms.forEach((row) => {
    row.loaded = true
    row.loading = false

    dataTmp.push(row);
  });
  return dataTmp;
};

//商品表API
const getListGoodsGiftPack = () => {
  storage.remove('goodsGiftPackPath')

   if (!dateStartRange.value || !dateEndRange.value) {
    defaultDate()
  }
  
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.brandname = query.brandid?query.brandid.join(','):''
  query.supplierids = query.supplierids?query.supplierids.join(','):''
  query.catalogid = query.catalogid?query.catalogid.join(','):''
  delete query.brandid
  console.log(query)

  listGoodsGiftPack(query).then((res) => {//queryParam.value
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    tableData.value = goodsReset(res.data.extend.pages.list);
    console.log(tableData.value)
    loadingData.value = false
  });
};

// const getGoodsGiftPackInfos = (goodsid)=>{
//     getGoodsGiftPackInfo({ goodsid}).then((res) => {
//         console.log(res)
//     });
// }

const doExportGoodsGiftPack = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  //queryParam.value.pageSize = 5000;
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.brandname = query.brandid?query.brandid.join(','):''
  query.supplierids = query.supplierids?query.supplierids.join(','):''
  query.catalogid = query.catalogid?query.catalogid.join(','):''
  query.pageSize = 10000
  delete query.brandid

  loadingexport.value = true;
  exportGoodsGiftPack(query).then((response) => {//queryParam.value
    downloadExcel(response);
  });
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
};


const validateDecimal = (rule, value, callback) => {
  //   const reg = /^d*(?:.d{0,2})?$/;
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入商品名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "名称长度2到200",
      trigger: "blur",
    },
  ],
  catalogid: [
    {
      required: true,
      message: "请选择类目",
      trigger: "change",
    },
  ],
  brandid: [
    {
      required: true,
      message: "请选择品牌",
      trigger: "change",
    },
  ],
  customerid: [
    {
      required: true,
      message: "请选择客户",
      trigger: "change",
    }
  ],
  activityname: [
    {
      required: true,
      message: "请输入活动名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 200,
      message: "名称活动2到200",
      trigger: "blur",
    },
  ],
  goodsnums: [
    {
      required: true,
      message: "请输入商品IDS",
      trigger: "blur",
    },
    {
      min: 2,
      max: 300,
      message: "IDS长度2到300",
      trigger: "blur",
    },
  ],
  // giftsku: [
  //   {
  //     required: true,
  //     message: "请输入礼包单品SKU编码",
  //     trigger: "blur",
  //   },
  //   {
  //     min: 2,
  //     max: 200,
  //     message: "SKU编码长度2到200",
  //     trigger: "blur",
  //   },
  // ],
  // specification: [
  //   {
  //     message: "请填写商品规格",
  //     trigger: "blur",
  //   },
  //   {
  //     min: 2,
  //     max: 100,
  //     message: "规格长度2到100",
  //     trigger: "blur",
  //   },
  // ],
});
</script>
<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-9);
}
</style>